module.exports = __webpack_public_path__ + "img/plan_move.bb25bf42.svg";